export default __webpack_public_path__ + "static/media/sun.2a706c68.png";